import BrokerHeroImage from '@images/use-cases/BrokerHeroImage.webp';
import FmosHeroImage from '@images/use-cases/FmosImage.webp';
import GeneralAgentsHeroImage from '@images/use-cases/GasImage.webp';
import TpasHeroImage from '@images/use-cases/TpasImage.webp';
import PeosHeroImage from '@images/use-cases/PeosImage.webp';
import type { StaticImageData } from 'next/image';

export type UseCaseExploreSlug =
    | 'brokers'
    | 'fmos'
    | 'general-agents'
    | 'tpas'
    | 'peos';

export type UseCaseExploreItem = {
    slug: UseCaseExploreSlug;
    title: string;
    description: string;
    href: string;
    image: StaticImageData | string;
    imageAlt: string;
};

export const USE_CASES_EXPLORE_ITEMS: UseCaseExploreItem[] = [
    {
        slug: 'brokers',
        title: 'Brokers',
        description:
            'Offer modern benefits solutions, win more clients, and simplify plan management with ICHRA.',
        href: '/use-cases/brokers',
        image: BrokerHeroImage,
        imageAlt: 'Brokers use case',
    },
    {
        slug: 'fmos',
        title: 'FMOs',
        description:
            'Empower your broker network with scalable ICHRA solutions and unlock new revenue streams without added complexity.',
        href: '/use-cases/fmos',
        image: FmosHeroImage,
        imageAlt: 'FMOs use case',
    },
    {
        slug: 'general-agents',
        title: 'General Agents (GAs)',
        description:
            'Reclaim your position in the distribution chain and power your broker network with a white-labeled ICHRA platform.',
        href: '/use-cases/general-agents',
        image: GeneralAgentsHeroImage,
        imageAlt: 'General Agents use case',
    },
    {
        slug: 'tpas',
        title: 'TPAs',
        description:
            'Streamline benefits administration and support ICHRA plans across multiple groups with a flexible, compliant infrastructure.',
        href: '/use-cases/tpas-third-party-administrators',
        image: TpasHeroImage,
        imageAlt: 'TPAs use case',
    },
    {
        slug: 'peos',
        title: 'PEOs',
        description:
            'Deliver modern, flexible benefits alongside your HR services — without adding operational complexity.',
        href: '/use-cases/peos-payroll-employment-organizations',
        image: PeosHeroImage,
        imageAlt: 'PEOs use case',
    },
];
